export default __webpack_public_path__ + "resources/icons/n110-d190.png";